import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarPublishedTuitionRatesResponse } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import { useSession } from 'next-auth/react'

export const useTuitionRates = () => {
  const session = useSession()
  const { siteId } = useSugarContext()

  return useQuery({
    enabled: session.status === 'authenticated' && Boolean(siteId),
    queryKey: ['tuitionRates', siteId],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarPublishedTuitionRatesResponse>('/api/published-tuition-rates', {
        params: { siteId },
        signal
      })

      return data.data
    },
    staleTime: ms('1h')
  })
}
